import { Component, OnInit } from '@angular/core';
import { Helper } from '../../../helpers/Helper';
import { UserService } from '../../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../../models/users/User';
import { SALARY_TYPE } from '../../../contants/SALARY_TYPE';
import { Salary } from '../../../models/salaries/salary';
import { AlertService } from '../../../services/alert.service';
import { SalaryService } from '../../../services/salary.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';

@Component({
	selector: 'app-salary-form',
	templateUrl: './salary-form.component.html',
	styleUrls: ['./salary-form.component.css']
})
export class SalaryFormComponent implements OnInit {
	user: User = new User;
	currentSalary: Salary = new Salary();
	hireDate: Date;

	form: FormGroup;
	
	constructor(
		private _activatedRoute: ActivatedRoute,
		private _userService: UserService,
		private _salaryService: SalaryService,
		private _router: Router,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		let id = this._activatedRoute.snapshot.params['id'];
		this.initForm();

		this._userService.getUser(id).subscribe(
			user => {
				if (user == undefined) {
					this._alertService.showError('User does not exist.')
				}
				else {
					this.user = user;
					this.hireDate = new Date(this.user.dateEmployed);

					if(this.user.salaryType === SALARY_TYPE.MONTHLY){
						this._userService.getMonthlyUserSalary(this.user.id).subscribe(
							result => {
								if(result != null){
									this.currentSalary = result;
								}
								else{
									this._alertService.showError("A problem occured while retrieving salary data.")
								}
							}
						);
					}
				}
			}
		);
	}

	private initForm() {
		this.form = new FormGroup({
			salaryType: new FormControl(this.user.salaryType, [
				Validators.required,
			]),
			amount: new FormControl(0),
			effectiveDate: new FormControl(new Date()),
			reason: new FormControl(''),
			remarks: new FormControl('', [
				Validators.maxLength(500)
			]),
		});

		this.form.get('salaryType').valueChanges.subscribe(
			salaryType => {
				var amount = this.form.get('amount');
				var effectiveDate = this.form.get('effectiveDate');
				var reason = this.form.get('reason');

				if(salaryType == SALARY_TYPE.MONTHLY){
					amount.setValidators([Validators.required]);
					effectiveDate.setValidators([Validators.required]);
					reason.setValidators([Validators.required, Validators.maxLength(20)]);
				}
				else{
					amount.clearValidators();
					effectiveDate.clearValidators();
					reason.clearValidators();
				}

				amount.updateValueAndValidity();
				effectiveDate.updateValueAndValidity();
				reason.updateValueAndValidity();
			}
		);
	}


	onFormSubmit(values){
		if(this.form.invalid){
			this._alertService.showError('Form is invalid.');
			return;
		}

		this.updateUser(values);
	}

	private updateUser(formValues){
		this.user.salaryType = formValues.salaryType;

		this._userService.updateUser(this.user).subscribe(
			result => {
				if(result != undefined){

					if(result.object.salaryType == SALARY_TYPE.MONTHLY){
						this.createSalary(formValues);
					}
					else{
						this.showSuccess();
					}
				}
				else{
					this._alertService.showGenericError();
				}
			}
		)
	}

	private createSalary(formValues){
		let salary = new Salary();
		salary.userId = this.user.id;
		salary.amount = formValues.amount;
		salary.effectiveDate = formValues.effectiveDate;
		salary.reason = formValues.reason;
		salary.remarks = formValues.remarks;

		this._salaryService.addSalary(salary).subscribe(
			result => {
				if(result != undefined){
					this.showSuccess();
				}
				else{
					this._alertService.showGenericError();
				}
			}
		);
	}

	private showSuccess() {
		this._alertService.showSuccess('New salary information has been applied.');
		this._router.navigate([APP_ROUTES.userForm.replace('/:id',''), this.user.id]);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/salaries/salary-form/salary-form.component.ts